import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ShopContext = createContext(null);

export function ShopProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const reloadSettings = () =>
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});

  useEffect(() => {
    reloadSettings();
  }, []);

  const maintenance = settings?.maintenance?.enabled ? settings.maintenance : null;

  return (
    <ShopContext.Provider value={{ settings, maintenance, reloadSettings }}>
      {children}
    </ShopContext.Provider>
  );
}

export const useShop = () => useContext(ShopContext);
